
import { Placement } from '@post-office/placements-frontend/goal-page-banners-placement';
export default Placement;
